<template>
  <custom-dialog class="change-sc-company-dialog" :appendToBody="true" :title="model.title" :visible="visible"
    v-on="$listeners" width="1200px">
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table :tableCode="tableCode" :data="tableList" :index="true" :slots="['newAfterServiceName']">
          <template v-slot:newAfterServiceName>
            <custom-select url="organRelationOrganList" v-model="tableId" :params="{ orgType: 'SC,JV_SC,HQ' }"
              :placeholder="$t('dms_change_sc_company_dialog.qxzshgs')" @change="onTableSelectChange" @getList="onGetList"
              :props="{ label: 'orgName', value: 'orgId', }" :dataFilter="dataFilter" :filterOptions="model.data"
              :filterable="true"></custom-select>
          </template>
        </custom-table>
      </div>
      <div class="person-title">{{ $t('dms_change_sc_company_dialog.szsbfzr') }}</div>
      <!-- 表单 -->
      <el-form :model="form" ref="form" label-width="150px" :inline="true">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('dms_change_sc_company_dialog.shgcs')" style="width: 100%">
              <custom-select :auto="false" v-model="form.technicianType" :listener="`${tableId}`" url="userAreaSelectList"
                :props="{ label: 'userName', value: 'userId', map: { userName: 'technicianName', mobile: 'technicianPhone' } }"
                :params="{ orgId: tableId }" width="100%" :model="form1" @getList="onPersonGetList"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dms_change_sc_company_dialog.shou_hou_zhu_guan')">
              <custom-select :auto="false" v-model="form.technicianType2" :listener="`${tableId}`"
                url="userAreaSelectList"
                :props="{ label: 'userName', value: 'userId', map: { userName: 'technicianName', mobile: 'technicianPhone' } }"
                :params="{ orgId: tableId }" width="100%" :model="form2"></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" :loading="submitting" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'change_sc_company_dialog',
      tableList: [],
      tableId: '',
      item: {},
      form: {
        technicianType: '',
        technicianType2: '',
      },
      form1: {
        technicianName: '',
        technicianPhone: '',
      },
      form2: {
        technicianName: '',
        technicianPhone: '',
      },
      selectList: [],
      submitting: false,

      // 负责人下拉列表
      personList: [],
    };
  },
  computed: {
    rules() {
      return {
        // technicianType: [
        //   {
        //     required: true,
        //     message: '请选择售后负责人',
        //
        //
        //   },
        // ],
      };
    },
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    onTableSelectChange() {
      this.form.technicianType = '';
      this.form.technicianType2 = '';
    },
    getPersonByUserId(userId) {
      const list = this.personList;
      return list.find(item => item.userId === userId);
    },
    dataFilter(list, filterOptions) {
      const { afterServiceId } = filterOptions;
      return list.filter(item => item.orgId !== afterServiceId);
    },
    onGetList(list) {
      this.selectList = list;
    },
    onPersonGetList(list) {
      this.personList = list;
    },
    // 初始化
    initDialog: function () {
      // this.tableId = this.model.data.orgId;
      this.tableList = [
        {
          ...this.model.data,
        }
      ];

    },
    getSubmitData() {
      const selectScItem = this.selectList.find(item => item.orgId === this.tableId);
      const { customOrgCode, orgId, orgName } = selectScItem;

      const ret = {
        afterServiceCustomCode: customOrgCode,
        afterServiceId: orgId,
        afterServiceName: orgName,
        deviceId: this.tableList[0].deviceId,
      };

      ret.technicianList = [

      ];

      if (this.form.technicianType) {

        // 第一售后负责人
        const firstPerson = this.getPersonByUserId(this.form.technicianType);
        const technician1 = {
          technicianId: firstPerson.userId,
          technicianName: firstPerson.userName,
          technicianPhone: firstPerson.mobile,
          technicianType: 1,
        };

        ret.technicianList.push(technician1);
      }


      if (this.form.technicianType2) {

        // 第二售后负责人
        const secondPerson = this.getPersonByUserId(this.form.technicianType2);

        const technician2 = {
          technicianId: secondPerson.userId,
          technicianName: secondPerson.userName,
          technicianPhone: secondPerson.mobile,
          technicianType: 2,
        };

        ret.technicianList.push(technician2);
      }

      return ret;

    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
    },
    // 确认保存
    confirm: function () {
      if (this.submitting) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.form.technicianType && this.form.technicianType === this.form.technicianType2) {
          // 第一 第二负责人重复
          const tips = this.$t('dms_change_sc_company_dialog.shgcsyshzgbnxzcf');
          this.$message.error(tips);
          return;
        }

        if (!this.tableId) {
          const tips = this.$t('dms_change_sc_company_dialog.qxzxshgs');
          this.$message.error(tips);
          return;
        }

        const submitData = this.getSubmitData();

        this.submitting = true;
        this.$postJSON(apis.deviceChangeSc, submitData, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_edit_success'),
          });
          this.$emit('success');
          this.closeDialog();
        }).finally(() => {
          this.submitting = false;
        });

      });
    },
    // 保存编辑
    saveUpdate: function () {

    },
    // 保存编辑(待分配工单)
    saveWaitUpdate: function () {

    },
  },
};
</script>

<style lang="scss">
.change-sc-company-dialog {
  .person-title {
    padding: 10px 0;
    color: #495057;
    margin-top: 20px;
    font-weight: bold;
  }
}
</style>
